export const OLD_CLI_WARNING_CUTOFF = 1612166400000; // Feb 1 2021 00:00:00 PST
export const PANEL_GEN_INFO_NUM_PANELS_THRESHOLD = 500; // preventative banner for panel gen awareness
export const AUTO_DISABLE_PANEL_GEN_THRESHOLD = 10_000; // auto-disable panel gen if workspace exceeds this many expected panels
export const CLEAR_PANELS_INFO_NUM_PANELS_THRESHOLD = 25_000; // escape hatch for large ws to quickly get out of bad state
